require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-empowering-beauty-opening-soon.json") })
        }
      }, "path---news-empowering-beauty-opening-soon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-empowering-beauty-opening-soon!./.cache/json/news-empowering-beauty-opening-soon.json
// module id = 807
// module chunks = 231608221292675